mutation UnsetHaftarahFromBarMitzvah($barMitzvah: String!) {
  unsetHaftarahFromBarMitzvah(barMitzvah: $barMitzvah) {
    ok
    errors
  }
}
